<template>
    <layout>
        <div class="row">
            <div class="col-sm-5">
                <!-- Profile block -->
                <div :class="[working ? 'block-opt-refresh' : '', 'block', 'block-rounded']">
                    <div class="block-content block-content-full text-center bg-amethyst">
                        <div class="item item-2x item-circle bg-crystal-op push-20-t push-20">
                            <i class="icon-user text-white-op"></i>
                        </div>
                        <div class="text-white-op push-10">
                            <h4>{{ inspector.user.contact.first_name }} {{ inspector.user.contact.last_name }}</h4>
                        </div>
                    </div>
                    <div class="block">
                        <ul class="nav nav-tabs nav-justified push-20" data-toggle="tabs">
                            <li class="active">
                                <a href="#tab-profile-personal" id="personal-btn" v-on:click.prevent="updateTab('personal')"><i class="fa fa-fw fa-pencil"></i> Personal</a>
                            </li>
                            <li>
                                <a href="#tab-profile-password" id="password-btn" v-on:click.prevent="updateTab('password')"><i class="fa fa-fw fa-asterisk"></i> Password</a>
                            </li>
                        </ul>
                        <div class="block-content tab-content">

                            <!-- Personal Tab -->
                            <div class="tab-pane fade in active" id="tab-profile-personal">

                                <div class="form-horizontal push-10-t">
                                    <div class="form-group">
                                        <div class="col-xs-6">
                                            <div class="form-material">
                                                <input class="form-control" type="text" v-model="inspector.user.contact.first_name">
                                                <label class="text-muted">First Name</label>
                                            </div>
                                        </div>
                                        <div class="col-xs-6">
                                            <div class="form-material">
                                                <input class="form-control" type="text" v-model="inspector.user.contact.middle_name">
                                                <label class="text-muted">Middle Name</label>
                                            </div>
                                        </div>
                                        <div class="col-xs-6">
                                            <div class="form-material">
                                                <input class="form-control" type="text" v-model="inspector.user.contact.last_name">
                                                <label class="text-muted">Last Name</label>
                                            </div>
                                        </div>
                                        <div class="col-xs-6">
                                            <div class="form-material">
                                                <input class="form-control" type="text" v-model="inspector.inspector_license">
                                                <label class="text-muted">ID#</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div class="col-sm-12">
                                            <div class="form-material">
                                                <input class="form-control" type="email" v-model="inspector.user.email">
                                                <label class="text-muted">Email</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div class="col-sm-12">
                                            <div class="form-material">
                                                <input class="form-control" type="text" v-model="inspector.user.contact.phone">
                                                <label class="text-muted">Phone</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div class="col-sm-12">
                                            <div class="form-material">
                                                <input class="form-control" type="text" v-model="inspector.user.contact.address">
                                                <label class="text-muted">Address</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div class="col-xs-6">
                                            <div class="form-material">
                                                <select class="form-control" v-model="inspector.user.contact.region_id">
                                                    <option v-for="region in regions" :value="region.id">{{ region.name }}</option>
                                                </select>
                                                <label class="text-muted">State</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>

                            <!-- Password Tab -->
                            <div class="tab-pane fade" id="tab-profile-password">
                                <div class="row items-push">
                                    <div class="col-sm-12 form-horizontal">
                                        <div class="form-group" v-bind:class="{ 'has-error': $v.password.$error }">
                                            <div class="col-xs-12">
                                                <label for="profile-password-new">New Password</label>
                                                <input class="form-control input-lg" type="password" v-model.trim="password" @input="$v.password.$touch()">
                                                <div class="help-block animated fadeInDown" v-if="!$v.password.minLength">Password must have at least {{ $v.password.$params.minLength.min }} letters.</div>
                                            </div>
                                        </div>
                                        <div class="form-group" v-bind:class="{ 'has-error': $v.repeatPassword.$error }">
                                            <div class="col-xs-12">
                                                <label for="profile-password-new-confirm">Confirm New Password</label>
                                                <input class="form-control input-lg" type="password" v-model.trim="repeatPassword" @input="$v.repeatPassword.$touch()">
                                                <div class="help-block animated fadeInDown" v-if="!$v.repeatPassword.sameAsPassword">Passwords must be identical.</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- END Password Tab -->



                        </div>

                        <div class="block-content block-content-full bg-gray-lighter text-center">
                            <button class="btn btn-primary"  v-on:click.prevent="updateInspector"><i class="fa fa-check push-5-r"></i> Save Changes</button>
                        </div>
                    </div>
                </div>
                <!-- END profile block -->


            </div>


            <div class="col-sm-7">
                <!-- Inspections block -->
                <div class="block block-rounded">
                    <div class="block-header">
                        <h4 class="block-title">Inspections</h4>
                    </div>
                    <div class="block-content block-content-full">
                        <div v-if="inspector.inspections.data.length > 0">
                            <table class="table table-hover table-vcenter table-clickable-rows">
                                <thead>
                                    <tr>
                                        <th style="width: 64px;"></th>
                                        <th>Inspection ID</th>
                                        <th>Contact Name</th>
                                        <th>Region</th>
                                        <th style="width: 100px;">Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="inspection in inspector.inspections.data" v-on:click="$router.push({ path: '/inspections/'+inspection.id })" v-bind:data-id="inspection.id">
                                        <td style="width: 64px;"><i class="icon-doc text-muted"></i></td>
                                        <td>{{ inspection.id }}</td>
                                        <td v-if="inspection.contact.first_name">{{ inspection.contact.first_name }} {{ inspection.contact.last_name }}</td>
                                        <td v-else><span class="text-muted">N/A</span></td>
                                        <td v-if="inspection.region">{{ inspection.region.abbr }}</td>
                                        <td v-else><span class="text-muted">N/A</span></td>
                                        <td class="status-badge-cell">
                                            <inspection-status-badge :inspection="inspection">
                                            </inspection-status-badge>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div v-else>
                            <div class="text-center text-muted">
                                <div class="item item-2x item-circle bg-gray-lighter push-20-t push-20">
                                    <i class="icon-ghost"></i>
                                </div>
                                <p>Forester currently has no inspections. <!--Click the button below to get started making a new inspection.--></p>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- END inspections block -->
            </div>
        </div>
    </layout>
</template>

<script>
    import { sameAs, minLength } from 'vuelidate/lib/validators';

    export default {
        name: 'inspectors-single',
        components: {
            layout: require('../layouts/default.vue'),
            inspectionStatusBadge: require('../elements/inspection-status-badge.vue'),
        },
        data () {
            return {
                regions: [],
                working: true,
                inspector: this.$schema.map('inspector'),

                password: null,
                repeatPassword: null
            };
        },
        methods: {
            updateTab (tab) {
                jQuery('#' + tab + '-btn').tab('show');
            },
            updateInspector () {
                this.working = true;

                if (this.password && !this.$v.$invalid || !this.password) {

                    if (this.password) {
                        // saveUser.password = this.password;
                        this.inspector.user.password = this.password;
                    }


                    this.axios.put('inspectors/' + this.$route.params.id, this.inspector).then((response) => {
                        this.$toasted.success('Forester details updated!');
                    }).then(() => {
                        this.getInspector();
                        this.working = false;
                    });
                } else {
                    this.$toasted.error('Password form has errors that need to be corrected.');
                    this.updateTab('password');
                    this.working = false;
                }
            },
            getInspector () {
                let self = this;
                this.working = true;

                this.axios.get('inspectors/' + this.$route.params.id + '?include=user,inspections.contact,inspections.region,inspections.status').then((response) => {
                    self.working = false;
                    self.inspector = response.data;
                    console.l
                });
            }
        },
        created () {
            this.axios.get('regions').then((response) => {
                this.regions = response.data.data;
            });

            this.getInspector();
        },
        validations: {
            password: {
                minLength: minLength(8)
            },
            repeatPassword: {
                sameAsPassword: sameAs('password')
            }
        },
    };
</script>



// WEBPACK FOOTER //
// foresters-single.vue?0ea827f8